var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myprofile"},[_c('div',{staticClass:"featured_article"},[_c('h1',{staticClass:"title"},[_vm._v("My Profile")]),_c('pep_user_profile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }